<template>
    <basic-page class="cookie-policy" :pagedata="this.pageData" bannerimg="/img/banner-policy.jpg">
        <div class="container-beige intro container" v-if="pageData.attributes.body!=undefined" v-html="this.pageData.attributes.body.processed"></div>
    </basic-page>
</template>

<script>
    import BasicPage from './BasicPage.vue'
    import {
        fetchSinglePage
    } from '../libs/drupalClient'
    export default {
        components: {
            BasicPage
        },
        name: 'cookie-policy',
        data: () => {
            return {
                currentPageId: "e0b22444-16aa-47bc-bb0b-4ecb701be29d",
                pageData: {
                    attributes: {}
                }
            }
        },
        computed: {
            lang() {
                return this.$store.state.currentLang
            },
            defaultLang() {
                return this.$store.state.defaultLang
            }
        },
        mounted() {
            fetchSinglePage(this.currentPageId, this.lang)
                .then(res => {
                    //console.log('res[0]', res[0]);
                    this.pageData = res[0]
                    //console.log(this.pageData)
                })
        },
        watch: {
            lang() {
                if(this.lang==this.defaultLang)
                    this.$router.push('/cookie-policy')
                else
                    this.$router.push('/' + this.lang + '/cookie-policy')

                fetchSinglePage(this.currentPageId, this.lang)
                    .then(res => { this.pageData = res[0] })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/colors.scss";

</style>